// src/store/services/DocumentosDeIdentificacion.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class DocumentosDeIdentificacion extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'DocumentosDeIdentificacion';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'documentos-de-identificacion';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'DocumentosDeIdentificacion',
    Model: DocumentosDeIdentificacion,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  